<script>
import swal from "sweetalert";
import {therapistsService} from "@/services";
export default {
  name: "UploadCertificate",
  props: ["therapistid"],
  data() {
    return {
      file: null,
      password: null,
      zapamietaj: false,
      saving: false,
      valid: true
    }
  },
  methods: {
    close() {
      this.$emit('close')
    },
    save()
    {
      if(this.file)
      {
        let formData = new FormData()
        formData.append('file',this.file);
        formData.append('keepPassword',this.zapamietaj)

        formData.append('password',this.password == null ? '' : this.password);
        formData.append('userid',this.therapistid);

        therapistsService.UploadTherapistCertificate(formData).then((response) => {
          this.$emit('uploaded',response.data.result)
        }).catch(error=> {
          let err =error.response
          if(err.data != null && err.data.error && err.data.error.message)
          {
            this.showError(err.data.error.message)
          }
          else
          {
            this.showError("Nie można wgrać pliku")
          }

        })
      }
      else
      {
        this.showError('Nie wybrano pliku')
      }
    },
    showError(text) {
      swal({
        title: "Błąd",
        text: text,
        icon: "warning",
        button: "OK"
      }).then(() => {
      });
    },
    handleSubmit() {
      if (this.$refs.form.validate()) {
        this.save();
      }
    },
    required: function (value) {
      if (value) {
        return true;
      } else {
        return 'To pole jest wymagane.';
      }
    },
  }
}
</script>

<template>
  <v-card>
    <v-card-title>
      <span class="headline">Wgrywanie certyfikatu</span>
    </v-card-title>
    <v-card-text>
      <v-progress-linear :indeterminate="true" v-if="saving"></v-progress-linear>
      <v-form @submit="handleSubmit"  v-model="valid"  ref="form" lazy-validation>
        <v-container fluid>
          <v-row>
            <v-col cols="12">
              <v-file-input
                  v-model="file"
                  label="Wybierz certyfikat"
                  outlined
                  prepend-icon="fa-paperclip"
              ></v-file-input>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="12" lg="12" md="12">
              <span>W przypadku nie podania hasła, certyfikat nie zostanie zweryfikowany.</span>
            </v-col>
            <v-col cols="12" sm="12" lg="6" md="6">
              <v-text-field label="Hasło"  v-model="password" ref="password" :type="'password'"></v-text-field>
            </v-col>
            <v-col cols="12" sm="12" lg="6" md="6">
              <v-checkbox v-model="zapamietaj" label="Zapamietaj hasło"></v-checkbox>
            </v-col>
          </v-row>
        </v-container>
      </v-form>
    </v-card-text>
    <v-card-actions>
      <v-btn @click="handleSubmit()" color="success">Wgraj certyfikat</v-btn>
      <v-spacer></v-spacer>
      <v-btn @click="close()" color="error">Zamknij</v-btn>
    </v-card-actions>
  </v-card>
</template>

<style scoped>

</style>